<template>
  <div class="m-pc-file">
    <div class="file-title">文件下载</div>
    <div class="file-list">
      <div class="file-all" v-show="isShowMulti">
        <!--<label class="file-check">-->
        <!--<input type="checkbox" v-model="isCheckAll" @change="checkAll()" />-->
        <!--<i><span class="check-icon"></span></i>-->
        <!--</label>-->
        <a-checkbox
          class="file-check"
          :indeterminate="isIndeterminate"
          @change="checkAll()"
          v-model="isCheckAll"
        >
        </a-checkbox>
        <span class="file-all-down" @click="downloadAll">全部下载</span>
      </div>
      <div class="file-item" v-for="item in fileList" :key="item.fileId">
        <div class="file-base">
          <a-checkbox
            @change="checkFile()"
            v-model="item.isCheck"
            v-show="isShowMulti"
          >
          </a-checkbox>
          <!--<label class="file-check" v-show="isShowMulti">-->
          <!--<input-->
          <!--type="checkbox"-->
          <!--v-model="item.isCheck"-->
          <!--@change="checkFile()"-->
          <!--/>-->
          <!--<i>-->
          <!--<span class="check-icon"></span>-->
          <!--</i>-->
          <!--</label>-->
          <img
            class="file-icon"
            :src="
              require('../assets/images/' + checkFileIcon(item.ext) + '.png')
            "
            alt=""
            :style="{ 'margin-left': !isShowMulti ? '0px' : '29px' }"
          />
          <span class="file-name">{{ item.name + "." + item.ext }}</span>
        </div>
        <div class="file-down" @click="downloadSingle(item)">
          下载
        </div>
      </div>
    </div>
    <div class="page-mask" v-if="isShowDownload">
      <div class="file-download">
        <div class="file-tips">请输入下载邮箱</div>
        <div class="file-input">
          <input type="text" class="file-email" v-model="email" />
          <div class="text-error" v-if="isShowError">
            请输入正确的邮箱
          </div>
        </div>
        <div class="file-operate">
          <div class="file-button cancle" @click="closeAll">
            取消
          </div>
          <div class="file-button major" @click="downloadFile">
            下载
          </div>
        </div>
      </div>
    </div>
    <div class="page-mask" v-if="isShowDownloadTips">
      <div class="file-download">
        <div class="file-down-tips">
          <div class="tips">
            {{ downTips }}
          </div>
          <div class="tips-sub">
            {{ downSubTips }}
          </div>
          <div class="file-button major know" @click="closeAll">
            <span class="icontemp quding"></span>知道了
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { $subscriber } from "fire-wind-water";
import service from "../services/article";
import { articleId, isSetting, initForm } from "../common/sbase";
import { fileListData } from "../common/settingData";
export default {
  name: "File",
  data() {
    return {
      fileList: [],
      isCheckAll: false,
      // isAllowedLike:true
      checkedFileList: [],
      isIndeterminate: false,
      info: {},
      email: "",
      isShowDownload: false,
      isShowDownloadTips: false,
      isShowError: false,
      downTips: "已下载成功",
      downSubTips: "稍后请查看你的邮箱",
      userInfo: {},
      isShowMulti: true //是否显示多文件下载
    };
  },
  created() {
    $subscriber.subscribe("article-info", info => {
      if (info) {
        if (isSetting) {
          this.fileList = fileListData;
        } else {
          this.getFileList(info.fileIds);
          this.info = info;
        }
        // this.isAllowedLike = info.isAllowedLike;
      }
    });
    $subscriber.subscribe("user-info", info => {
      if (info) {
        this.userInfo = info;
      }
    });
  },
  methods: {
    getFileList(fileIds) {
      let self = this;
      if (fileIds) {
        service.getFileList({ fileIds: fileIds.split("|") }).subscribe(data => {
          if (data.result == 0) {
            self.fileList = data.content.map(item => {
              if (item.folderDownloadType == "1") {
                //0邮件下载  1直接下载
                this.isShowMulti = false; //如果其中有一个位直接下载 隐藏多选下载
              }
              item.isCheck = false;
              return item;
            });
          }
        });
      }
    },
    checkAll() {
      this.checkedFileList = [];
      this.fileList.forEach(item => {
        item.isCheck = this.isCheckAll;
        // if(this.isCheckAll) {
        //   this.checkedFileList.push(item.fileId);
        // }
      });
      this.isIndeterminate = false;
      console.log(this.checkedFileList);
    },
    checkFile() {
      let i = 0;
      this.checkedFileList = [];
      this.fileList.forEach((item, index, arr) => {
        if (item.isCheck) {
          i++;
          // this.checkedFileList.push(item.fileId);
          if (i == arr.length) {
            this.isCheckAll = true;
          }
        } else {
          this.isCheckAll = false;
        }
        if (i > 0 && !this.isCheckAll) {
          this.isIndeterminate = true;
        } else {
          this.isIndeterminate = false;
        }
      });
    },

    downloadAll() {
      this.checkedFileList = [];
      let isNeedOpen = true;
      this.fileList.forEach(item => {
        if (item.isCheck) {
          this.checkedFileList.push(item.fileId);
          debugger;
          if (item.identity == "3" && this.userInfo.session == "") {
            initForm(
              item.identity,
              this.info.schemaId,
              item.registerFormId,
              this.info.tenantId,
              "pc",
              () => {}
            );
            isNeedOpen = false;
          }
        }
      });
      if (this.checkedFileList.length && isNeedOpen) {
        this.isShowDownload = true;
      }
    },
    downloadSingle(item) {
      initForm(
        item.identity,
        this.info.schemaId,
        item.registerFormId,
        this.info.tenantId,
        "pc",
        () => {
          if (item.folderDownloadType == "0") {
            this.isShowDownload = true;
            this.checkedFileList = [item.fileId];
            this.isShowDownload = true;
          } else {
            window.open(item.fileDownloadUrl);
          }
        }
      );
    },

    downloadFile() {
      const reg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
      if (!reg.test(this.email)) {
        this.isShowError = true;

        return;
      } else {
        this.isShowError = false;
      }
      let param = {
        articleId: articleId,
        openId: this.userInfo.openId || "",
        globalUserId: this.userInfo.globalUserId,
        fileList: this.checkedFileList,
        email: this.email,
        forEmailTemp: 0,
        referenceUrl: window.location.href,
        moduleType: this.info.moduleId,
        instanceId: this.info.instanceId,
        sess: this.userInfo.session,
        extra: {
          tenantId: this.info.tenantId,
          instanceId: this.info.instanceId,
          memberId: this.userInfo.memberId || "",
          moduleId: this.info.moduleId,
          openId: this.userInfo.openId || "",
          weChatId: this.info.weChatId,
          objInstanceId: this.info.weChatId,
          source: "PC"
        }
      };
      service.downloadWithEmail(param).subscribe(data => {
        if (data.result == 0) {
          this.isShowDownload = false;
          if (data.content.isReview == 1) {
            this.downTips = "申请已提交";
            this.downSubTips = "审核通过后可从邮件中下载";
          } else {
            this.downTips = "已下载成功";
            this.downSubTips = "稍后请查看你的邮箱";
          }
          this.email = "";
          this.isShowDownloadTips = true;
        }
      });
    },
    closeAll() {
      this.isShowDownload = false;
      this.isShowDownloadTips = false;
    },
    checkFileIcon(item) {
      if (["zip", "rar"].indexOf(item) > -1) {
        return "zip";
      } else if (["doc", "docx"].indexOf(item) > -1) {
        return "doc";
      } else if (["mp3", "wav", "flac", "ape"].indexOf(item) > -1) {
        return "audio";
      } else if (["ppt", "pptx"].indexOf(item) > -1) {
        return "ppt";
      } else if (["xls", "xlsx"].indexOf(item) > -1) {
        return "xls";
      } else if (["pdf", "txt"].indexOf(item) > -1) {
        return item;
      } else if (["swf", "flv"].indexOf(item) > -1) {
        return "flash";
      } else if (
        [
          "mp4",
          "vod",
          "mkv",
          "avi",
          "rm",
          "rmvb",
          "mpeg2",
          "ts",
          "wmv",
          "3gp"
        ].indexOf(item) > -1
      ) {
        return "video";
      } else if (
        ["jpg", "jpeg", "gif", "png", "svg", "tif", "bmp"].indexOf(item) > -1
      ) {
        return "image";
      } else {
        return "unknown";
      }
    }
  },
  components: {}
};
</script>
